<brightside-web-required-legal-documents
[documentsKey]="documentsKey"
(termsSubmittedEvent)="termsAccepted($event)">
</brightside-web-required-legal-documents>
